module.exports = __webpack_public_path__ + "img/wd-back.ef155182.png";